import { render, staticRenderFns } from "./VideoMain.vue?vue&type=template&id=0f9e0f7d&scoped=true&"
import script from "./VideoMain.vue?vue&type=script&lang=js&"
export * from "./VideoMain.vue?vue&type=script&lang=js&"
import style0 from "./VideoMain.vue?vue&type=style&index=0&id=0f9e0f7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9e0f7d",
  null
  
)

export default component.exports